import React from 'react'

import { Form, Col } from '_zari/core'

const InputFormGroup = ({ setFieldValue }) => {
  return (
    <Form.Group>
      <Form.Label text='SUBIR LOGO EXTERNO' htmlFor='inputfile-file' md={12} />
      <Col md={12}>
        <Form.InputFile
          id='inputfile-file'
          name='file'
          onChange={e => {
            setFieldValue('file', e.currentTarget.files[0])
          }}
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(InputFormGroup)
